import React, { FC, ReactNode } from 'react'
import '../icon.scss'

export const IV24rzMehrfamilienhausIcon: FC<ReactNode> = () => {
  return (
    <div className='icon-container iv24-icon-container'>
      <img
        src={
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/b419a266617db9eb3dbb5b8325bf5f0d_210526-CI_Immoverkauf24-ICONS-rz_mehrfamilienhaus.svg'
        }
        alt={''}
      />
    </div>
  )
}
